import { AppUsers } from "./AppUsers";
import { DataSafe } from "@/models/DataSafe"


interface StringKeyArray {
    [index: string]: number;
}

export class MoodData{
    static attributePrefix = "Mood";
    static attributePrefixDe = "Stimmung";

//    static getMyAttributeNumbers(){
//        // see DataSafe !!!
//        const attributes: StringKeyArray = {
//            "fearful":10,
//            "happy":11,
//            "calm":12,
//            "confident":13,
//            "sexy":14,
//            "angry":15,
//            "emotional":16,
//            "stressed":17,
//        };
//        return attributes;
//    }
//
//    static getSetUpArray(){
//        return  {
//            "fearful":false,
//            "happy":false,
//            "calm":false,
//            "confident":false,
//            "sexy":false,
//            "angry":false,
//            "emotional":false,
//            "stressed":false,
//          };
//    }
//
//    static getMyAttributeFormSettings(){
//        const attributeFormSettings = {
//            "fearful":{"icon":'PhThinSmileyNervous',"valuetype":'bool'},
//            "happy":{"icon":'PhLightSmiley',"valuetype":'bool'},
//            "calm":{"icon":'mdiMeditation',"valuetype":'bool'},
//            "confident":{"icon":'mdiStarFace',"valuetype":'bool'},
//            "sexy":{"icon":'mdiFire',"valuetype":'bool'},
//            "angry":{"icon":'BsEmojiAngry ',"valuetype":'bool'},
//            "emotional":{"icon":'mdiSineWave',"valuetype":'bool'},
//            "stressed":{"icon":'BsLightningCharge ',"valuetype":'bool'},
//        }
//        return attributeFormSettings;
//    }
//    
//    /* @ts-ignore */
//    static async insertOrUpdateToDate(vals,ValueDate){
//    
//        await AppUsers.getMyUser().then((user) => {
//            let vars = {};
//            let myAttributes = MoodData.getMyAttributeNumbers();
//            let defaultKeys = Object.keys(myAttributes);
//            for(var i = 0; i < defaultKeys.length; i++){
//                let helpkey = defaultKeys[i];
//
//                if(typeof vals[helpkey] != 'undefined'){
//                    /* @ts-ignore */
//                    vars[myAttributes[helpkey]] = vals[helpkey];
//                }
//            }
//
//            DataSafe.insertOrUpdateToDate(user.sysId, vars, ValueDate );
//        });
//    }
//
//    static async getMyDayValues(ShowDate: Date){
//        return await AppUsers.getMyUser().then((user) => {
//            //console.log(Object.values(ProfileData.getMyAttributeNumbers()));
//            let myAttributes = MoodData.getMyAttributeNumbers();
//            return DataSafe.getDayValuesToAttributes(user.sysId, Object.values(myAttributes), ShowDate ).then((res) => {
//                let defaultRet = MoodData.getSetUpArray();
//                let defaultKeys = Object.keys(defaultRet);
//                for(var i = 0; i < defaultKeys.length; i++){
//                    let helpkey = defaultKeys[i];
//                    //console.log(myAttributes[helpkey])
//                    if(typeof res.get(myAttributes[helpkey]) != 'undefined'){
//                        //console.log(res.get(myAttributes[helpkey]).value)
//                        /* @ts-ignore */
//                        defaultRet[helpkey] = res.get(myAttributes[helpkey]).value;
//                    }
//                }
//                return defaultRet;
//            });
//        });
//    }
}
